import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  FormGroup,
  Input,
  Label,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import Breadcrumbs from "../../components/Common/Breadcrumb"

export const SmtpSettings = () => {
  const [modal_large, setmodal_large] = useState(false)

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function tog_large() {
    setmodal_large(!modal_large)
    removeBodyCss()
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>SMTP Settings | Matrimonial Admin</title>
        </MetaTags>
        <div className="container-fluid">
          <Row>
            <Breadcrumbs
              maintitle="Dashboard"
              title="Master"
              breadcrumbItem="SMTP Settings"
            />
            <Col sm={6}></Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Row>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <AvField
                            name="ServerName"
                            label="Server Name"
                            placeholder="Server Name"
                            type="text"
                            errorMessage="Enter Server Name"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="ServerName"
                          />
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup className="mb-3">
                          <AvField
                            name="SMTPPassword"
                            label="SMTP Password"
                            placeholder="SMTP Password"
                            type="password"
                            errorMessage="Enter SMTP Password"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="SMTPPassword"
                          />
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup className="mb-3">
                          <AvField
                            name="SMTPUserName"
                            label="SMTP User Name"
                            placeholder="SMTP User Name"
                            type="text"
                            errorMessage="Enter SMTP User Name"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="SMTPUserName"
                          />
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup className="mb-3">
                          <AvField
                            name="SMTPPort"
                            label="SMTP Port"
                            placeholder="SMTP Port"
                            type="number"
                            errorMessage="Enter SMTP Port"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="SMTPPort"
                          />
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup className="mb-3">
                          <AvField
                            label="SMTP From Email"
                            name="email"
                            placeholder="Enter Valid Email Id"
                            type="email"
                            errorMessage="Invalid Email Id"
                            validate={{
                              required: { value: true },
                              email: { value: true },
                            }}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="12">
                        <div className="form-check">
                          <Label
                            className="form-check-label"
                            htmlFor="Allow_Candidate"
                          >
                            {" "}
                            SMTP Enable SSL
                          </Label>
                          <Input
                            type="checkbox"
                            className="form-check-input"
                            id="Allow_Candidate"
                          />
                        </div>
                      </Col>
                    </Row>
                    <Button color="primary" className="mt-3" type="submit">
                      Save
                    </Button>{" "}
                    <Button
                      color="outline-primary"
                      className="mt-3"
                      type="button"
                    >
                      Cancel
                    </Button>{" "}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}
